import _ from 'lodash'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import Toast from './components/Toast'
import styles from '../../styles.scss'

// todo: toaster
// control animation times // this would require jss to set the animaion time in the css as well

class Toaster extends Component {
    getAnimationClasses = () => {
        if (this.props.animation !== 'none') {
            return {
                enterActive: styles.active,
                exitActive: styles.active,
                enter: styles[`${this.props.animation}_enter`],
                exit: styles[`${this.props.animation}_exit`],
            }
        }
        return ''
    }

    getToasterClassNames = () => {
        const { position, layout, showButton } = this.props

        const classNames = styles('toaster', {
            top_right: position === 'topRight',
            bottom_right: position === 'bottomRight',
            top_left: position === 'topLeft',
            bottom_left: position === 'bottomLeft',
            left: layout === 'left',
            has_menu: showButton,
        })

        return classNames
    }

    renderMenu = () => {
        if (!this.props.showButton) return null

        return (
            <button
                className={`${styles.menu} flaticon flaticon-message31`}
                onClick={() => this.props.toggleMenu()}
            />
        )
    }

    renderAnimatedToasts = () => {
        const { toasts } = this.props
        const classNames = this.getAnimationClasses()

        const timeout = this.props.animation !== 'none' ? 1000 : 0

        let result = _.mapValues(toasts, (toastProps) => {
            const toast = this.renderToast(toastProps.id, toastProps.isMessage, toastProps)
            return (
                <CSSTransition key={toastProps.id} timeout={timeout} classNames={classNames}>
                    {toast}
                </CSSTransition>
            )
        })

        result = _.values(result)

        return result
    }

    renderToast = (id, isMessage, props) => (
        <Toast {...props} onDismissClick={() => this.props.removeToast(id, isMessage)} />
    )

    renderToasts = () => {
        const { toasts } = this.props

        if (_.size(toasts) < 1) return null

        const animatedToasts = this.renderAnimatedToasts()

        return <TransitionGroup component={'ul'}>{animatedToasts}</TransitionGroup>
    }

    render() {
        const { showButton, toasts } = this.props

        if (!showButton && _.size(toasts) < 1) return null

        const menu = this.renderMenu()
        const classNames = this.getToasterClassNames()
        const t = this.renderToasts()

        return (
            <div className={classNames}>
                {menu}
                <div style={{ overflow: 'auto', width: '100%' }} />
                {t}
            </div>
        )
    }
}

Toaster.propTypes = {
    showButton: PropTypes.bool,
    toasts: PropTypes.arrayOf(PropTypes.object).isRequired,
    position: PropTypes.oneOf(['topRight', 'bottomRight', 'topLeft', 'bottomLeft']),
    removeToast: PropTypes.func,
    animation: PropTypes.oneOf(['none', 'fade', 'slide']),
    toggleMenu: PropTypes.func,
    layout: PropTypes.string,
}

Toaster.defaultProps = {
    position: 'topRight',
    animation: 'none',
}

export default Toaster



// WEBPACK FOOTER //
// ./src/features/Toaster/components/Toaster/component.js